<template>
  <Flex
    direction="column"
    justify="center"
    align="center"
    v-test="'migrate-website-error'"
  >
    <BaseStatusIcon state="error" />
    <BaseHeading>
      {{ noWebsite ? $t('wavy_onboarding.migrate_website.error_no_website.heading') : $t('wavy_onboarding.migrate_website.error_generic.heading') }}
    </BaseHeading>
    <BaseText center>
      {{ noWebsite ? $t('wavy_onboarding.migrate_website.error_no_website.description') : $t('wavy_onboarding.migrate_website.error_generic.description') }}
    </BaseText>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
const props = defineProps<{
  noWebsite: boolean;
}>();
</script>
